<template>
  <div class="user" :key="user.id">
    <div class="profile">
      <div
        :style="{
          backgroundImage: `url(${user.avatar || images.avatar})`,
        }"
        class="avatar"
      ></div>
      <div>
        <div class="nickname">
          {{ user.nickname }}
        </div>
        <div class="actions">
          <md-button class="edit" @click="onEditClick" v-if="isOwner">
            <i class="iconfont iconbianji" />{{ $t("userEdit.edit") }}
          </md-button>
          <c-share>
            <i class="share iconfont iconfenxiang" />
          </c-share>
        </div>
      </div>
    </div>
    <md-button class="upload" @click="onPublishClick" v-if="isOwner">
      <i class="iconfont iconupload" />{{ $t("upload") }}
    </md-button>
    <md-tabs class="tabs">
      <md-tab
        id="tab-created"
        :md-label="$t('publish.public') + ' ' + mineCount"
        exact
      >
        <c-led-list
          class="list"
          :key="mineKey"
          :query="{ user_id: user.id, ordering: '-id' }"
          @change="onMineCountChange"
          @liked="changeLike"
          @deleted="changeLike"
          v-if="user.id"
        />
        <div class="empty" v-if="mineCount === 0">
          <i class="iconfont iconempty" />
          <span v-if="isOwner">{{ $t("publish.empty") }}</span>
          <md-button
            class="empty-upload"
            @click="onPublishClick"
            v-if="isOwner"
          >
            {{ $t("publish.upload") }}
          </md-button>
        </div>
      </md-tab>
      <md-tab
        id="tab-save"
        :md-label="$t('publish.nonPublic') + ' ' + saveCount"
        v-if="isOwner"
      >
        <c-led-list
          class="list"
          :query="{ user_id: user.id, ordering: '-id' }"
          isDraft
          @change="onSaveCountChange"
          @deleted="changeLike"
          v-if="user.id"
        />
        <div class="empty" v-if="saveCount === 0">
          <i class="iconfont iconempty" />
          <span v-if="isOwner">{{ $t("publish.empty") }}</span>
          <md-button
            class="empty-upload"
            @click="onPublishClick"
            v-if="isOwner"
          >
            {{ $t("publish.upload") }}
          </md-button>
        </div>
      </md-tab>
      <md-tab id="tab-liked" :md-label="$t('like') + ' ' + likedCount">
        <c-led-list
          class="list"
          :key="likeKey"
          :query="{ user_id: user.id, ordering: '-id' }"
          isLiked
          @change="onLikedCountChange"
          @liked="changeMine"
          v-if="user.id"
        />
        <div class="empty" v-if="likedCount === 0">
          <i class="iconfont iconempty" />
          <span v-if="isOwner">{{ $t("publish.likeEmpty") }}</span>
        </div>
      </md-tab>
    </md-tabs>
  </div>
</template>
<script>
import { mapState } from "vuex";
import api, { url } from "@/api";
export default {
  name: "User",
  data() {
    return {
      user: {},
      mineCount: "",
      likedCount: "",
      saveCount: "",
      mineKey: "mine",
      likeKey: "like",
    };
  },
  computed: {
    ...mapState("assets", {
      images: "images",
    }),
    ...mapState("user", {
      isSignIn: "isSignIn",
      uuid: "uuid",
    }),
    isOwner() {
      return !(
        this.$route.params.uuid && this.$route.params.uuid !== this.uuid
      );
    },
  },
  methods: {
    getUser() {
      api.getUser(this.$route.params.uuid).then((res) => {
        this.user = res;
      });
    },
    changeMine() {
      this.mineKey = "mine" + new Date().getTime();
    },
    changeLike() {
      this.likeKey = "like" + new Date().getTime();
    },
    onEditClick() {
      window.open(url.userEdit, "_blank");
    },
    onPublishClick() {
      this.$router.push(this.$paths.publish);
    },
    onMineCountChange({ count }) {
      this.mineCount = count;
    },
    onLikedCountChange({ count }) {
      this.likedCount = count;
    },
    onSaveCountChange({ count }) {
      this.saveCount = count;
    },
  },
  mounted() {
    this.getUser();
  },
  watch: {
    ["$route.params.uuid"]() {
      this.getUser();
    },
  },
};
</script>
<style lang="scss" scoped>
.user {
  height: 100%;
  text-align: center;
  color: #ffffff;
  padding: 50px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
  position: relative;

  .profile {
    @include flex-center;
    margin-bottom: 20px;

    .avatar {
      width: 135px;
      height: 135px;
      border-radius: 50%;
      background: $primary-color no-repeat center / cover;
      margin-right: 45px;
      display: flex;
      align-items: flex-end;
      justify-content: flex-end;
    }

    .nickname {
      height: 1.5em;
      font-size: 38px;
      font-weight: bold;
      color: #ffffff;
      text-align: left;
    }

    .actions {
      display: flex;
      align-items: center;
      margin-top: 10px;

      .edit {
        @include flex-center;
        height: 50px;
        line-height: 50px;
        border-radius: 10px;
        font-size: 16px;
        color: #ffffff;

        border: 1px solid #ffffff;
        margin: 0 15px 0 0;

        i {
          margin-right: 5px;
          font-size: 17px;
          vertical-align: bottom;
        }
      }

      .share {
        @include icon-hover;
        font-size: 34px;
        color: #ffffff;
      }
    }
  }

  .upload {
    height: 50px;
    line-height: 50px;
    background: $primary-color;
    border-radius: 10px;
    font-size: 16px;
    color: #ffffff;
    position: absolute;
    right: 100px;
    top: 210px;

    i {
      margin-right: 10px;
      font-size: 16px;
      vertical-align: bottom;
    }
  }

  .tabs {
    width: 100%;
    padding: 0 100px;

    .list {
      height: calc(100vh - 450px - #{$header-height} - #{$footer-height});
    }

    .empty {
      @include flex-center;
      flex-direction: column;
      padding: 60px 0;
      font-size: 20px;
      color: #ffffff;

      i {
        font-size: 50px;
        margin-bottom: 10px;
      }

      .empty-upload {
        height: 50px;
        line-height: 50px;
        background: $primary-color;
        border-radius: 10px;
        font-size: 16px;
        margin-top: 30px;
      }
    }
  }
}
</style>

<style lang="scss">
.user {
  .tabs {
    .md-tabs-navigation {
      border-bottom: 1px solid #595959;
      padding: 15px 0;

      .md-button-content {
        font-size: 20px;
        text-transform: none;
      }

      .md-tabs-indicator {
        display: none;
      }
    }
  }
}
</style>
